// @flow
import { formatPrice } from '@src/utils/general';
import { fullSizeShapeImagePath } from '@src/utils/images';

import css from '@styles/productDetail/recentlyViewed';

import type { RecentlyViewedDiamondSummaryType } from '@types/diamond';

type TProps = { items: Array<RecentlyViewedDiamondSummaryType> };

export default function RecentlyViewedDiamonds({ items }: TProps) {
  const navigateToDetail = (id: number) => {
    if (window) window.location = `/diamonds/detail/${id}`;
  };

  if (items.length === 0) return null;

  return (
    <div>
      <h2 className={css.title}>Recently Viewed</h2>
      <div className={css.listContainer}>
        {items.map((item, i) => {
          return (
            <div
              key={i}
              className={css.listItem}
              onClick={() =>
                navigateToDetail(
                  item.list_service_diamond_id || item.rapnet_diamond_id // rapnet id can be removed after idex deploy + a couple of months
                )
              }
            >
              <div className={css.imageSquareContainer}>
                <div className={css.imageBox}>
                  <img
                    className={css.image}
                    src={fullSizeShapeImagePath(item)}
                  />
                </div>
              </div>
              <div className={css.description}>{item.description}</div>
              <div className={css.price}>{formatPrice(item.price)}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
